import CreateEvent from '../components/CreateEvent';
import PageLayout from '../components/pageLayout';

function CreateEventPage() {
    return (
        <PageLayout children={<CreateEvent />} />
    );
}

export default CreateEventPage;
